if (!customElements.get('category-carousel')) {
  customElements.define('category-carousel', class CategoryPicker extends HTMLElement {
    constructor() {
      super()
      this.categoryChange = this.categoryChange.bind(this)
      this.showNewDescription = this.showNewDescription.bind(this)
      this.updateCategoryViewportWidths = this.updateCategoryViewportWidths.bind(this)

      this.track = this.querySelector('.carousel-track')
      this.categoryViewports = this.querySelectorAll('.category-viewport')

      document.addEventListener('category-picker-change', this.categoryChange)
      window.addEventListener('resize', this.updateCategoryViewportWidths)

      this.updateCategoryViewportWidths()
    }

    categoryChange(event) {
      const number = event.detail.number
      const groupWidth = this.querySelector('.carousel-viewport').clientWidth
      this.track.style.marginLeft = `${number * -1 * groupWidth}px`

      this.categoryViewports.forEach((v, i) => {
        v.setAttribute('aria-hidden', i === number ? 'false' : 'true')
        v.setAttribute('tabindex', i === number ? '0' : '-1')
      })

      const oldDesc = this.querySelector('.description:not(.tw-hidden)')
      if (!oldDesc) { this.showNewDescription(number); return; }

      oldDesc.addEventListener('transitionend', function () {
        oldDesc.classList.add('tw-hidden')
        this.showNewDescription(number)
      }.bind(this), { once: true })
      oldDesc.classList.remove('tw-opacity-100')
      oldDesc.classList.add('tw-opacity-0')
    }

    showNewDescription(number) {
      const newDesc = this.querySelector(`#description-${number}`)
      if (!newDesc) return
      newDesc.classList.remove('tw-hidden', 'tw-opacity-0')
      newDesc.classList.add('tw-opacity-100')
    }

    updateCategoryViewportWidths() {
      const viewport = this.querySelector('.carousel-viewport')
      this.categoryViewports.forEach((v, i) => {
        v.style.width = `${viewport.clientWidth}px`
        v.setAttribute('aria-hidden', i === 0 ? 'false' : 'true')
        v.setAttribute('tabindex', i === 0 ? '0' : '-1')
      })
    }
  })
}
